// src/components/Footer.js
import React from 'react';
import { Container } from 'react-bootstrap';
import '../css/Footer.css'

import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

function Footer() {
  const position = [24.3513878, 54.4959206]; // Default position, replace with actual lat/lon later

//const Footer = () => {
  return (
    

    
    // <footer style={{ backgroundColor: 'rgb(0, 51, 102)', padding: '20px 0', marginTop: 'auto' }}>
    <footer >
      <Container className='footer' style={{width: 'inherit'}} >
        <div className='location'>
            <div className='text'>
                <h4 className='h4'>Quality Pharmacy</h4>
                <h3 className='h3'>WE CARE FOR YOUR HEALTH </h3>

                <div className="information">
                    <div>9249 Middle Country Rd, Selden</div>
                    <div> <span>,NY</span> <span>11784</span></div>
                    <div>United States</div>
                    <br></br><br></br>
                    {/* <div style={{display:'flex', flexWrap: 'wrap', alignItems: 'flex-end' }}> */}
                    <div >
                    <div>Phone:&nbsp;&nbsp;&nbsp;<a style={{textDecoration:'none'}} href="tel:+16317327373">(631) 732-7373</a></div>
                    <div className="contact-info">Fax:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a style={{textDecoration:'none'}}>(631) 732-0013</a></div>
                    </div>
                </div>


                <div className="office_hours">
                    <div class="row"><div class="day">Monday</div><div class="time">9:00 am - 7:00 pm</div></div>
                    <div class="row"><div class="day">Tuesday</div><div class="time">9:00 am - 7:00 pm</div></div>
                    <div class="row"><div class="day">Wednesday</div><div class="time">9:00 am - 7:00 pm</div></div>
                    <div class="row"><div class="day">Thursday</div><div class="time">9:00 am - 7:00 pm</div></div>
                    <div class="row"><div class="day">Friday</div><div class="time">9:00 am - 7:00 pm</div></div>
                    <div class="row"><div class="day">Saturday</div><div class="time">9:00 am - 5:00 pm</div></div>
                    <div class="row"><div class="day">Sunday</div><div class="time">Closed</div></div>
                </div>
		

            </div>

            <div className="map">
              <iframe
                title="Quality Pharmacy - Selden NY"
                src="https://www.google.com/maps/embed?pb=!1m19!1m8!1m3!1d96547.71309889849!2d-73.1085159!3d40.8693277!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x89e846e91adb651d%3A0x6f5c733e8f825b1!2s249%20Middle%20Country%20Rd%2C%20Selden%2C%20NY%2011784%2C%20United%20States!3m2!1d40.869357!2d-73.0261151!5e0!3m2!1sen!2s!4v1761063878691!5m2!1sen!2s"
                width="70%"
                height="450"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              ></iframe>
            </div>
        </div>
        <div className='footer-strip' style={{ marginTop: '50px' }}>
          <div>&copy; {new Date().getFullYear()} Quality Pharmacy. All rights reserved.</div>

          <div style={{ display: 'flex', alignItems: 'center' }}>
          <a className='link1' href='./terms-and-conditions'>Terms and Conditions</a>
            <span style={{ margin: '0 5px' }}>&nbsp;|&nbsp;</span>
            <a className='link1' href='./privacy-policy'>Privacy Policy</a>
          </div>
        </div>
        
        {/* <div className="row text-center">
          &copy; {new Date().getFullYear()} Shoreham Drugs. All rights reserved.
        </div> */}
      </Container>
    </footer>
  );
}

export default Footer;
